<template>
  <div>
    <v-autocomplete
      v-model="customer"
      :items="customerItems"
      :loading="isLoading"
      :search-input.sync="search"
      @input="$emit('onSelect', $event)"
      item-text="labelSearch"
      item-value="objectId"
      return-object
      outlined
      v-bind="$attrs"
      hide-no-data
      ref="selectCustomer"
      :menu-props="{ closeOnContentClick: true }"
    >
      <template v-slot:item="{ item, attrs, on, parent }">
        <v-list-item v-if="!item.addCustomer" v-bind="attrs" v-on="on">
          <v-list-item-content>
            <v-list-item-title>
              <div>{{ item.fullNameNoTitle }}</div>
              <div>
                <small>{{ item.fullTels }}</small>
              </div>
              <div>
                <small>{{ item.fullEmails }}</small>
              </div>
              <div>
                <small>{{ item.citizenId }}</small>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else>
          <v-btn color="success" @click="isSelect = true;" block elevation="0">{{ $t('customer.add_customer') }}</v-btn>
        </v-list-item>
      </template>
      <template v-slot:no-data>
        <v-list-item>
          <v-btn color="success" @click="isSelect = true;" block elevation="0">{{ $t('customer.add_customer') }}</v-btn>
        </v-list-item>
      </template>
    </v-autocomplete>
    <form-customer
      :event="customerEvent"
      v-model="addCustomer"
      :objectId="customerObj.objectId"
      @onUpdated="changeProfileOutput"
      :customerType="isSelectedCustomer"
    ></form-customer>
    <customer-select
      v-model="isSelect"
      :emitData="false"
      @onSelected="selectedCustomer"
      @onCreated="
        giveCustomerSelect($event);
        isSelect = false;
      "
    ></customer-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomerSelect from "./CustomerSelect.vue";
import FormCustomer from "./FormCustomer.vue";
export default {
  components: { FormCustomer, CustomerSelect },
  name: "SelectCustomer",
  props: {
    value: Object,
  },
  computed: {
    ...mapGetters({
      getSearchCustomers: "customer/getSearchCustomers"
    }),
    customerItems(){
      let items = []
      if (this.getSearchCustomers) items = [...this.getSearchCustomers]
      if (this.customer) items.push(this.customer)
      items.push({ addCustomer: true, labelSearch: this.search ? this.search : undefined })
      return items
    }
  },
  watch: {
    search(val) {
      clearTimeout(this.delay);
      if (val != null) {
        this.delay = setTimeout(async () => {
          if (!val.addCustomer) {
            this.isLoading = true;
            await this.$store.dispatch("customer/getCustomerByKeyword", {
              keyword: val
            });
            this.isLoading = false;
          } else {
            return;
          }
        }, 700);
      }
    },
    value: {
      handler(val) {
        if (val) {
          this.search = val.labelSearch
          this.customer = val;
        } else {
          this.customer = null;
          this.search = null;
        }
      },
      deep: true
    },
    customer: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true
    }
  },
  data() {
    return {
      isSelect: false,
      isLoading: false,
      search: null,
      delay: null,
      addCustomer: false,
      customerEvent: "create",
      customerObj: {},
      isProfileLoading: false,
      isSelectedCustomer: "personal",
      customer: null,
    };
  },
  created() {
    this.customer = null;
    this.search = null;
  },
  methods: {
    selectedCustomer(val) {
      this.isSelectedCustomer = val;
      this.addCustomer = true;
    },
    changeProfileOutput(val) {
      this.customer = Object.assign({}, val);
      this.$emit("onSelect", this.customer);
    },
    giveCustomerSelect(val) {
      this.customer = Object.assign({}, val);
      this.$emit("onSelect", this.customer);
    },
    addProfile() {
      this.customerEvent = "create";
      this.addCustomer = true;
    },
    searchCustomer(val){
      clearTimeout(this.delay);
      if (val != null) {
        this.delay = setTimeout(async () => {
          if (!val.addCustomer) {
            this.isLoading = true;
            await this.$store.dispatch("customer/getCustomerByKeyword", {
              keyword: val
            });
            this.isLoading = false;
          } else {
            return;
          }
        }, 700);
      }
    },
  }
};
</script>
